const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

export const DEFAULT_API_BASE_URL = '';

const normalizeBaseUrl = (value: string | undefined): string => {
  const normalized = (value ?? '').trim();
  if (!normalized) {
    return '';
  }
  return normalized.endsWith('/') ? normalized.slice(0, -1) : normalized;
};

export const API_BASE_URL =
  normalizeBaseUrl(import.meta.env.VITE_API_BASE_URL) || DEFAULT_API_BASE_URL;

export const isAbsoluteUrl = (value: string): boolean => ABSOLUTE_URL_PATTERN.test(value);

export function buildApiUrl(path: string): string {
  if (isAbsoluteUrl(path)) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
